import apiRequest from "utils/ApiRequest/apiRequest.js";
import config from "config";

export const daysAgo = (date) => {
  const today = new Date();
  const creationDate = new Date(date);
  const months = today.getMonth() - creationDate.getMonth();
  //if hours / 24*30 - moth
  if (months > 0) {
    return new Date(date).toLocaleString();
  } else {
    const sum = today.getDate() - creationDate.getDate();
    if (sum > 0) {
      return sum + " notification-days-ago";
    } else {
      const hours = today.getHours() - creationDate.getHours();
      if (hours > 0) {
        return hours + " notification-hours-ago";
      } else {
        return 1 + " notification-hours-ago";
      }
    }
  }
};

export const sortList = (array) => {
  if (array) {
    let sortedArray = array.sort(function compare(a, b) {
      var dateA = new Date(a.CreationDate);
      var dateB = new Date(b.CreationDate);
      return dateB - dateA;
    });
    return sortedArray;
  }
};

export const redirectByClick = (notification, language) => {
  if (notification.NotificationLinkUrl || notification.NotificationLinkTarget) {
    if (notification.NotificationLinkUrl) {
      const baseUrl = config.baseurl;
      let newUrl;
      if (notification.NotificationLinkUrl.includes("http")) {
        window.open(
          notification.NotificationLinkUrl,
          notification.NotificationLinkTarget
        );
      } else {
        if (notification.NotificationLinkUrl.includes("/")) {
          const tempUrl = notification.NotificationLinkUrl.split("/en/");
          newUrl = baseUrl + "/" + language + "/" + tempUrl[tempUrl.length - 1];
        } else {
          const tempUrl = notification.NotificationLinkUrl.split("/en/");
          newUrl = baseUrl + "/" + language + "/" + tempUrl[tempUrl.length - 1];
        }
        if (notification.NotificationLinkTarget) {
          window.open(newUrl, notification.NotificationLinkTarget);
        } else {
          window.location.href = newUrl;
        }
      }
    }
  }
};

export const newLinkUrl = (notification, language) => {
  let url = "";
  if (notification.NotificationLinkUrl) {
    if (notification.NotificationLinkUrl) {
      const baseUrl = config.baseurl;
      let newUrl;
      if (notification.NotificationLinkUrl.includes("http")) {
        newUrl = notification.NotificationLinkUrl;
      } else {
        if (notification.NotificationLinkUrl.includes("/")) {
          const tempUrl = notification.NotificationLinkUrl.split("/en/");
          newUrl = baseUrl + "/" + language + "/" + tempUrl[tempUrl.length - 1];
        } else {
          const tempUrl = notification.NotificationLinkUrl.split("/en/");
          newUrl = baseUrl + "/" + language + "/" + tempUrl[tempUrl.length - 1];
        }
      }
      url = newUrl;
    }
  }

  return url;
};

export const getSpecialNotification = async ({
  notification,
  culture,
  setSpecialNotification,
  setNotExistSegnments,
}) => {
  const parameters = {
    notificationSystemName: notification,
    culture: culture,
  };
  const response = await apiRequest(
    "Notifications",
    "GetSpecificNotification",
    parameters
  );
  if (response.status === "success") {
    setSpecialNotification(response.data);
    if (!response.data) {
      setNotExistSegnments(true);
    }
  } else {
    setNotExistSegnments(true);
  }
};
